import React, { useEffect, useState } from "react";
import WhatsAppAPI from "../api/WhatsAppAPI";

const EmbeddedSignup = () => {
  const [status, setStatus] = useState("Ready");
  const [isLoading, setIsLoading] = useState(false);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    // Load FB SDK
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "662219482864172",
        autoLogAppEvents: true,
        xfbml: true,
        version: "v23.0",
      });
      // console.log("Facebook SDK initialized");
      setStatus("SDK Ready");
    };

    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.referrerPolicy = "strict-origin-when-cross-origin";
    document.body.appendChild(script);

    // Message listener for Meta signup events (sync wrapper - FB/code expects function, not async)
    const onMessage = async (event) => {
      if (!event.origin.endsWith("facebook.com")) return;

      try {
        const data = JSON.parse(event.data);
        // console.log("Meta Signup Event:", data);

        if (data.type === "WA_EMBEDDED_SIGNUP") {
          switch (data.event) {
            case "FINISH":
            case "FINISH_ONLY_WABA":
            case "FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING":
              const { phone_number_id, waba_id, business_id } = data.data;
              console.log("data.data", data.data);
              // console.log("Signup FINISHED:", { phone_number_id, waba_id, business_id });

              try {
                let saveResponse = await WhatsAppAPI.saveWABAInfo({
                  phone_number_id,
                  waba_id,
                  business_id,
                  event: data.event,
                });
                console.log("saveResponse", saveResponse);
                setStatus("Signup Completed & Saved");
              } catch (err) {
                console.error("Saving session failed:", err);
                setStatus("Signup Completed but DB Save Failed");
              }
              setIsLoading(false);
              break;

            case "CANCEL":
              const step = data.data?.current_step || "unknown step";
              setStatus(`User cancelled at: ${step}`);
              setIsLoading(false);
              break;

            case "ERROR":
              const errMsg = data.data?.error_message || "Unknown error";
              console.error("Signup error:", errMsg);
              setStatus(`Error: ${errMsg}`);
              setIsLoading(false);
              break;

            default:
              console.warn("Unhandled event:", data.event);
          }
        }
      } catch (e) {
        console.warn("Non-JSON message received:", event.data);
      }
    };

    const handleMessage = (event) => {
      onMessage(event);
    };
    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const fbLoginCallback = async (response) => {
    // console.log("FB.login response:", response);

    if (response.authResponse?.code) {
      const code = response.authResponse.code;
      setStatus("Code received, exchanging...");
      try {
        let exchangedToken = await WhatsAppAPI.exchangeAccessToken(code);
        setStatus(
          "Code exchanged. Waiting for signup completion...",
          exchangedToken,
          code,
        );
      } catch (err) {
        console.error("Token exchange error:", err);
        setStatus("Token Exchange Failed");
        setIsLoading(false);
      }
    } else {
      setStatus("Login failed or not authorized");
      setIsLoading(false);
    }
  };

  const launchWhatsAppSignup = () => {
    setIsLoading(true);
    setStatus("Launching signup...");
    // FB.login expects a sync callback; wrap async callback so it receives a function, not async
    window.FB.login(
      (response) => {
        fbLoginCallback(response);
      },
      {
        config_id: "712558518089402",
        response_type: "code",
        override_default_response_type: true,
        extras: {
          sessionInfoVersion: "3",
          setup: {},
          featureType: "whatsapp_business_app_onboarding",
        },
        auth_type: "rerequest",
        redirect_uri: "https://admin.watconnect.com/api/auth/facebook/callback", // Add this
      },
    );
  };

  return (
    <div style={styles.container}>
      <h3 style={styles.heading}>WhatsApp Business Embedded Signup</h3>

      <button
        onClick={launchWhatsAppSignup}
        disabled={isLoading}
        style={{
          ...styles.button,
          ...(hover ? styles.buttonHover : {}),
          ...(isLoading ? styles.buttonDisabled : {}),
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {isLoading ? "Setting up..." : "Setup WhatsApp Business"}
      </button>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    background:
      "linear-gradient(180deg, var(--theme-canvas, #e9f0ec) 0%, #ffffff 40%, var(--theme-color-3, #e4f4ec) 100%)",
    color: "#0f172a",
    fontFamily: "Arial, sans-serif",
  },
  heading: {
    fontSize: "2rem",
    marginBottom: "20px",
  },
  status: {
    fontSize: "1rem",
    marginBottom: "20px",
    padding: "10px 20px",
    backgroundColor: "rgba(28, 183, 121, 0.08)",
    borderRadius: "20px",
    color: "#0f172a",
  },
  button: {
    backgroundColor: "#1cb779",
    color: "#ffffff",
    padding: "14px 28px",
    border: "none",
    borderRadius: "8px",
    fontSize: "1rem",
    fontWeight: "bold",
    cursor: "pointer",
    boxShadow: "0 4px 14px rgba(28, 183, 121, 0.35)",
    transition: "all 0.3s ease",
  },
  buttonHover: {
    backgroundColor: "#169463",
    transform: "scale(1.02)",
  },
  buttonDisabled: {
    backgroundColor: "#cccccc",
    color: "#666666",
    cursor: "not-allowed",
    transform: "none",
  },
  debugInfo: {
    marginTop: "30px",
    textAlign: "center",
    opacity: 0.7,
  },
};

export default EmbeddedSignup;
